/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Component, effect, input } from '@angular/core';
import { CalendarDaySection, CommonUtils } from '@infodata-group/inf-commons';
import jsPDF from 'jspdf';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'infl-calendar-hours',
  templateUrl: './calendar-hours.component.html',
  standalone: true,
  styleUrls: ['./calendar-hours.component.scss'],
  imports: [CommonModule],
})
export class CalendarHoursComponent {
  public start = input({ hours: 7, minutes: 0 });
  public end = input({ hours: 17, minutes: 30 });
  public hourDivCount = input(2);
  public withGroup = input(false);
  public canDrag = input(false);
  public canResize = input(false);

  public sections: CalendarDaySection[];
  public lastSection: CalendarDaySection;

  constructor() {
    effect(() => {
      if (this.hourDivCount()) {
        this.buildZone();
      }
    });
  }

  private buildZone() {
    this.sections = [];
    let i = this.start().hours;
    for (i; i < this.end().hours; ++i) {
      const section = new CalendarDaySection(i);
      section.generateSubZones(this.start(), this.end(), this.hourDivCount());
      this.sections.push(section);
    }
    if (this.end().minutes > 0) {
      const section = new CalendarDaySection(i);
      section.generateSubZones(this.start(), this.end(), this.hourDivCount());
      this.sections.push(section);
    }
    this.lastSection = this.sections[this.sections.length - 1];
  }

  public generatePDF(doc: jsPDF) {
    let y = 100;
    const x = 10;
    for (const section of this.sections) {
      for (const sub of section.zones) {
        doc.text(
          CommonUtils.convertTimeToString({
            hours: sub.hour,
            minutes: sub.minutes,
          }),
          x,
          y,
        );
        if (sub.minutes > 0) {
          doc.setDrawColor(CommonUtils.color('grey-c8'));
          doc.setLineDashPattern([2.5], 2);
        } else {
          doc.setDrawColor(CommonUtils.color('black'));
          doc.setLineDashPattern(null, 0);
        }
        doc.line(x + 30, y, doc.internal.pageSize.width - 10, y);
        y += 30;
      }
    }
  }
}
